import { Button, Grid } from '@mui/material';
import ViewMessageDeleteStyles from './ViewMessageDelete.styles';
import SightLoading from '../Loading/SightLoading';
import { useState } from 'react';
import useRequests from '@hooks/requests.hook';
import { useSnackbar } from 'notistack';

interface Props {
	onClose(): void;
	id_rango: number;
	setIsOpen: any;
}

const ViewMessageDelete: React.FC<Props> = ({ onClose, id_rango, setIsOpen }) => {
	const classes = ViewMessageDeleteStyles();
	const [isLoading, setLoading] = useState<boolean>(false);
	const [mesaggeResponse, setMesaggeResponse] = useState<boolean>(false);
	const { enqueueSnackbar } = useSnackbar();

	const { request } = useRequests();

	const eliminarRangoAgw = async () => {
		setLoading(true);
		try {
			const response = await request(
				'clientes/suite-maestro-rangos/rango-maestro',
				'DELETE',
				{
					id_rango: id_rango,
				}
			);

			// se valida la respuesta negativa de la petición
			if (response.isError === true) {
				throw new Error(response.message);
				// se envian datos de respuesta a ventana emergente de error y se muestran
			}

			if (response.isError === false) {
				setLoading(false);
				setIsOpen(false);
				setMesaggeResponse(true);
			}
		} catch (error: any) {
			setLoading(false);
			if (typeof error?.message === 'string') {
				enqueueSnackbar(error.message, { variant: 'error' });
			} else if (error.response && error.response.data.message) {
				enqueueSnackbar(error.response.data.message, { variant: 'error' });
			}
		}
	};

	return (
		<>
			{isLoading && <SightLoading show={true} />}

			{!mesaggeResponse ? (
				<div className={classes.root}>
					<div className={classes.rootC} />
					<section className={classes.card}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<h5 className={classes.tittle}>
									¿Deseas eliminar este rango de guías?
								</h5>
							</Grid>
						</Grid>
						<Grid container spacing={0}>
							<Grid item xs={6}>
								<Button
									onClick={onClose}
									className={classes.buttonC}
									variant="contained"
								>
									CANCELAR
								</Button>
							</Grid>
							<Grid item xs={6}>
								<Button
									onClick={() => eliminarRangoAgw()}
									className={classes.buttonA}
									variant="contained"
								>
									ACEPTAR
								</Button>
							</Grid>
						</Grid>
					</section>
				</div>
			) : (
				<div className={classes.root}>
					<div className={classes.rootC} />
					<section
						style={{ width: '346px', height: '130px', textAlign: 'left' }}
						className={classes.card}
					>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<h5
									style={{ textAlign: 'left', marginLeft: 30, marginBottom: 18 }}
									className={classes.tittle}
								>
									Este rango de guías se ha
									<br /> eliminado exitosamente
								</h5>
							</Grid>
						</Grid>
						<Grid container spacing={0}>
							<Grid item xs={6}>
								<Button
									onClick={onClose}
									className={classes.button}
									variant="contained"
								>
									CERRAR
								</Button>
							</Grid>
						</Grid>
					</section>
				</div>
			)}
		</>
	);
};

export default ViewMessageDelete;
